import { render, staticRenderFns } from "./BussinessProcessButton.vue?vue&type=template&id=d360d128&scoped=true&"
import script from "./BussinessProcessButton.vue?vue&type=script&lang=js&"
export * from "./BussinessProcessButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d360d128",
  null
  
)

export default component.exports
import {QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QBtn,QTooltip}, component.options.components || {})
